import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Popconfirm } from "antd";
import filterTypes from "data/filter-types";
import tagTypes from "data/tag-types";
import findFilterValue from "helpers/find-filter-value";
import getTreesFromMeters, { getMetersFromTrees } from "helpers/get-trees-from-meters";
import searchOperationGenerator from "helpers/search-operation-generator";
import smartPercentCalculator from "helpers/smart-percent-calculator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import withFilters from "views/lib/HOC/withFilters";
import { getUsersFilters } from "actions/users/actions";
import { getNoPagination } from "actions/tag/actions";

const existsOptions = [
  {
    label: "Exits",
    value: true
  },
  {
    label: "Not Exist",
    value: false
  },
];

class UserFilers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      reRender: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getUsersFilters();
    this.props.getTags([{
      fieldName: "type",
      fieldValue: tagTypes.user,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (nextState.reRender !== this.state.reRender) {
      return true;
    } else if (nextProps.usersTotalCount !== this.props.usersTotalCount) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {},
      reRender: true
    }, () => {
      this.setState({
        reRender: false
      });
      this.props.handleReset();
    });
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      activeFilters,
      totalCount,
      usersFilters,
      tags,
      usersTotalCount
    } = this.props;
    const {
      isOpen,
      // filters,
      reRender,
    } = this.state;

    if (reRender) {
      return null;
    }

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title={
            <div>
              Users

              <Popconfirm
                title="Are you sure?"
                onConfirm={this.props.handleExport}
                placement="bottomRight"
                okText="Yes"
                cancelText="Cancel"
              >
                <button className="btn btn-success btn-sm ml-2">
                  Export
                </button>
              </Popconfirm>
              <button
                className="btn btn-warning btn-sm ml-2"
                onClick={this.props.handleNotificationModal}
              >
                Send Notification <FontAwesomeIcon icon={faComment}/>
              </button>
            </div>
          }
          totalCount={`(${smartPercentCalculator(0, usersTotalCount, totalCount)
            .toFixed(2)}%) ${totalCount}`}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-2" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="id"
                  placeholder="ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(usersFilters.id)}
                  value={findFilterValue("id", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="name"
                  placeholder="First Name"
                  filterType="text"
                  filterTypeOptions={existsOptions}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(usersFilters.name, [filterTypes.EQUALS.value])}
                  value={findFilterValue("name", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="surname"
                  placeholder="Last Name"
                  filterType="text"
                  exitsTypeOptions={existsOptions}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(usersFilters.surname, [filterTypes.EQUALS.value])}
                  value={findFilterValue("surname", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="email"
                  placeholder="Email"
                  filterType="email"
                  exitsTypeOptions={existsOptions}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(usersFilters.email, [filterTypes.EQUALS.value])}
                  value={findFilterValue("email", activeFilters)}
                />
              </div>

              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="tags"
                  placeholder="Tags"
                  filterType="select_multiple"
                  filterTypeOptions={tags.map(value => ({
                    label: value.name,
                    value: value.name
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.IN.value])}
                  value={findFilterValue("tags", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="gender"
                  placeholder="gender"
                  filterType="select"
                  filterTypeOptions={[{
                    label: "Male",
                    value: "MALE"
                  }, {
                    label: "Female",
                    value: "FEMALE"
                  }]}
                  exitsTypeOptions={existsOptions}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.EQUALS.value, filterTypes.EXIST.value])}
                  value={findFilterValue("gender", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="birthday"
                  placeholder="Age"
                  filterType="select"
                  filterTypeOptions={[
                    "0-5",
                    "6-10",
                    "11-15",
                    "16-20",
                    "21-25",
                    "26-30",
                    "31-35",
                    "36-40",
                    "41-45",
                    "46-45",
                    "51-55",
                    "56-60",
                    "61-65",
                    "66-70",
                    "71-75",
                    "76-80",
                    "81-85",
                    "86-90",
                    "91-95",
                    "95-100",
                  ].map(item => ({
                    label: item,
                    value: item,
                  }))}
                  onChange={(name, valueObject) => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (valueObject && valueObject.hasOwnProperty("fieldValue")) {
                      const currentYear = moment()
                        .format("YYYY");
                      const values = valueObject.fieldValue.split("-");
                      const startYear = moment(`dd-mm-${currentYear - values[1]}`)
                        .startOf("year")
                        .valueOf();
                      const endYear = moment(`dd-mm-${currentYear - values[0]}`)
                        .endOf("year")
                        .valueOf();
                      valueObject = {
                        fieldName: "birthday",
                        fieldValue: [startYear, endYear],
                        searchOperation: filterTypes.BETWEEN.value,
                      };
                    }
                    this.handleChangeFilter("birthday", valueObject);
                  }}
                  searchOperation={searchOperationGenerator(null, [filterTypes.BETWEEN.value])}
                  value={findFilterValue("birthday", activeFilters)}

                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="birthday"
                  placeholder={["Birthday From", "To"]}
                  filterType="date_range"
                  exitsTypeOptions={existsOptions}
                  onChange={(name, valueObject) => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (valueObject && valueObject.hasOwnProperty("fieldValue") && valueObject.searchOperation !== filterTypes.EXIST.value) {
                      const startYear = moment(valueObject.fieldValue[0])
                        .startOf("day")
                        .valueOf();
                      const endYear = moment(valueObject.fieldValue[1])
                        .endOf("day")
                        .valueOf();
                      valueObject = {
                        fieldName: "birthday",
                        fieldValue: [startYear, endYear],
                        searchOperation: filterTypes.BETWEEN.value,
                      };
                    }
                    this.handleChangeFilter("birthday", valueObject);
                  }}
                  searchOperation={searchOperationGenerator(null, [filterTypes.BETWEEN.value, filterTypes.EXIST.value])}
                  value={findFilterValue("birthday", activeFilters)
                  && Array.isArray(findFilterValue("birthday", activeFilters))
                    ? findFilterValue("birthday", activeFilters)
                      .map(d => (d ? moment(d) : null))
                    : findFilterValue("birthday", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="hasCard"
                  placeholder="Has Card"
                  filterType="select"
                  filterTypeOptions={existsOptions}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.EQUALS.value])}
                  value={findFilterValue("hasCard", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="created"
                  placeholder={["Registered From", "To"]}
                  filterType="date_range"
                  onChange={(name, valueObject) => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (valueObject && valueObject.hasOwnProperty("fieldValue") && valueObject.searchOperation !== filterTypes.EXIST.value) {
                      const startYear = moment(valueObject.fieldValue[0])
                        .startOf("day")
                        .valueOf();
                      const endYear = moment(valueObject.fieldValue[1])
                        .endOf("day")
                        .valueOf();
                      valueObject = {
                        fieldName: "created",
                        fieldValue: [startYear, endYear],
                        searchOperation: filterTypes.BETWEEN.value,
                      };
                    }
                    this.handleChangeFilter("created", valueObject);
                  }}
                  searchOperation={searchOperationGenerator(null, [filterTypes.BETWEEN.value])}
                  value={findFilterValue("created", activeFilters)
                  && Array.isArray(findFilterValue("created", activeFilters))
                    ? findFilterValue("created", activeFilters)
                      .map(d => (d ? moment(d) : null))
                    : findFilterValue("created", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="distance"
                  placeholder="Saved Trees"
                  filterType="number"
                  onChange={(name, valueObject) => {
                    // eslint-disable-next-line no-prototype-builtins
                    this.handleChangeFilter(name, {
                      ...valueObject,
                      fieldValue: getMetersFromTrees(valueObject.fieldValue) || 0
                    });
                  }}
                  searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
                  value={getTreesFromMeters(parseInt(findFilterValue("distance", activeFilters), 10)) || null}
                />
              </div>
              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="lastActionDate"
                  placeholder="Last Action"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.MORE.value, filterTypes.LESS.value])}
                  value={findFilterValue("lastActionDate", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-12 mb-2">
                <div
                  className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

UserFilers.defaultProps = {
  activeFilters: []
};

UserFilers.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleExport: PropTypes.func.isRequired,
  handleNotificationModal: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  usersFilters: state.users.usersFilters,
  usersTotalCount: state.users.usersTotalCount,
  tags: state.tag.tagListNoPagination,
});

const mapStateToDispatch = dispatch => ({
  getUsersFilters: bindActionCreators(getUsersFilters, dispatch),

  getTags: bindActionCreators(getNoPagination, dispatch),
});

export default withFilters(connect(
  mapStateToProps,
  mapStateToDispatch
)(UserFilers));



// WEBPACK FOOTER //
// ./src/views/pages/users/filters.js